import React from "react";

// v18-D "rust in het ontwerp": gedeelde stukken. Tegels wit, alleen rood bij aandacht; een sectie = één kaart.
export const TEGEL = "border rounded-[10px] px-3 py-2.5";
export const TEGEL_WIT = "bg-white border-zinc-200";
export const TEGEL_LABEL = "text-[10px] font-bold uppercase tracking-[.07em] text-zinc-500 leading-tight";
export const TEGEL_ROOD = "bg-rose-100 border-rose-200";
const isNul = (v) => v === 0 || v === "0";
export const getalKleur = (value, rood) => (isNul(value) ? "text-zinc-400" : rood ? "text-rose-600" : "text-zinc-900");
export const TEGEL_GETAL = "font-mono font-extrabold text-2xl md:text-[28px] leading-tight mt-0.5";

// rood = alleen voor "Te laat" / "Rood" / "Rood zonder afspraak"; kleurt pas bij een waarde > 0.
export const Tegel = ({ label, value, sub, rood, testid }) => {
  const r = rood && !isNul(value);
  return (
    <div data-testid={testid} className={`${TEGEL} ${r ? TEGEL_ROOD : TEGEL_WIT}`}>
      <div className={TEGEL_LABEL}>{label}</div>
      <div className={`${TEGEL_GETAL} ${getalKleur(value, r)}`}>{value}</div>
      {sub && <div className="text-[11px] text-zinc-500 mt-0.5">{sub}</div>}
    </div>
  );
};

// Zwarte sectiekop; het blok direct eronder sluit erop aan (zie .tw1-sec in index.css). `los` = kop boven een raster.
export const SectieKop = ({ titel, aantal, hint, testid, accent, actie, los }) => (
  <div data-testid={testid} className={`tw1-sec ${los ? "tw1-sec-los" : ""} flex flex-wrap items-center gap-x-2 gap-y-1 bg-zinc-950 text-white px-3 py-2 ${accent ? "border-l-[6px] border-amber-400" : ""}`}>
    <span className="font-heading font-black uppercase tracking-[.06em] text-xs">{titel}</span>
    {aantal != null && <span className="font-mono text-[10.5px] leading-4 bg-white text-zinc-950 rounded px-1.5">{aantal}</span>}
    {hint && <span className="ml-auto text-right text-[11px] font-medium normal-case tracking-normal text-zinc-400">{hint}</span>}
    {actie && <span className={hint ? "" : "ml-auto"}>{actie}</span>}
  </div>
);

export const LIJST = "bg-white border border-zinc-200 rounded-[10px] divide-y divide-zinc-200";
export const KAART = "bg-white border border-zinc-200 rounded-[10px]";
export const SECTIE_RUIMTE = "mb-3 md:mb-4";
export const KNOP_IN_KOP = "px-2.5 py-1 rounded-md bg-white text-zinc-950 text-xs font-semibold hover:bg-zinc-200 transition-colors";
